import isEmpty from 'lodash/isEmpty';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Waypoint } from 'react-waypoint';

import { gettext } from '@eb/i18n';
import { Icon } from '@eb/eds-icon';

import {
    ARTIST_SOCIAL_LINKS_PROPTYPE,
    SOCIAL_TYPE_ICON_MAP,
} from '../../../../constants';

const ARTIST_PLACEHOLDER_STYLES = {
    backgroundColor: '#EFF2F5',
    width: '100%',
    height: '100%',
    borderRadius: '100%',
};

const _generateSocialLinks = (socialLinks) =>
    socialLinks.map(({ type, url }) => {
        const iconType = SOCIAL_TYPE_ICON_MAP[type];

        let component = null;

        if (iconType) {
            component = (
                <a
                    key={type}
                    className="
                        artist-attribution__social-link
                        eds-l-pad-all-3
                        eds-l-mar-hor-1
                    "
                    href={url}
                    rel="noopener noreferrer nofollow"
                    target="_blank"
                >
                    <Icon type={iconType} />
                </a>
            );
        }

        return component;
    });

const ArtistSocialLinks = ({ socialLinks, linkClasses }) => {
    let component = null;
    const classes = classNames('eds-l-pad-top-4', linkClasses);

    if (!isEmpty(socialLinks)) {
        component = (
            <div className={classes}>{_generateSocialLinks(socialLinks)}</div>
        );
    }

    return component;
};

const ArtistInfo = ({
    name,
    summary,
    socialLinks,
    wrapperClasses,
    infoClasses,
    linkClasses,
}) => {
    const wrapperClassName = classNames('eds-g-cell', wrapperClasses);

    return (
        <div className={wrapperClassName}>
            <div className={infoClasses}>
                <p className="eds-text-bl eds-text-color--grey-700">
                    {gettext('Page art by')}
                </p>
                <p className="eds-text-hm eds-text-color--grey-700">{name}</p>
                <p className="eds-text-color--grey-600 eds-l-pad-top-4">
                    {summary}
                </p>
            </div>
            <ArtistSocialLinks
                socialLinks={socialLinks}
                linkClasses={linkClasses}
            />
        </div>
    );
};

const ArtistImage = ({ name, image }) => {
    let imageElement = (
        <span
            className="artist-attribution__placeholder-image"
            style={ARTIST_PLACEHOLDER_STYLES}
        />
    );

    if (image) {
        imageElement = (
            <img
                src={image}
                alt={name}
                className="artist-attribution__image full-width-img"
            />
        );
    }

    return (
        <div className="artist-attribution__image-container eds-g-cell eds-g-cell-2-12">
            {imageElement}
        </div>
    );
};

export class ArtistAttribution extends React.PureComponent {
    static propTypes = {
        image: PropTypes.string,
        summary: PropTypes.string,
        name: PropTypes.string,
        socialLinks: ARTIST_SOCIAL_LINKS_PROPTYPE,
    };

    state = {
        visible: false,
    };

    _handleWaypointEnter = () => {
        this.setState({ visible: true });
    };

    render() {
        const { image, summary, name, socialLinks } = this.props;

        let component = null;

        if (name) {
            let imageURL = image;

            if (!this.state.visible) {
                imageURL = undefined;
            }

            component = (
                <div className="artist-attribution">
                    <div className="eds-align--center eds-l-pad-vert-10">
                        <ArtistImage image={imageURL} name={name} />
                        <ArtistInfo
                            name={name}
                            summary={summary}
                            socialLinks={socialLinks}
                            wrapperClasses="eds-g-cell-4-12 eds-show-up-mn"
                            infoClasses="eds-l-pad-left-10"
                            linkClasses="eds-l-pad-left-6 "
                        />
                    </div>
                    <ArtistInfo
                        name={name}
                        summary={summary}
                        socialLinks={socialLinks}
                        wrapperClasses="eds-show-down-sw eds-g-cell-10-12 eds-g-offset-1-12 eds-text--center eds-l-mar-top-4"
                    />
                </div>
            );
        }

        return (
            <Waypoint onEnter={this._handleWaypointEnter}>{component}</Waypoint>
        );
    }
}
